import { ShieldCheck, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { PANEL_URL } from "@/lib/api";

export default function Admin() {
  return (
    <div className="mx-auto max-w-2xl">
      <div className="tm-card p-10 text-center" data-testid="admin-panel-card">
        <ShieldCheck className="mx-auto h-10 w-10 text-tm-gold" />
        <h1 className="mt-4 font-display text-2xl font-extrabold text-tm-green">Taxmandi Admin Panel</h1>
        <p className="mt-2 text-slate-600">The same admin panel used for the mobile app: users, verification, membership, video moderation, promo codes, offers and more.</p>
        <Button asChild className="mt-6 rounded-full bg-tm-green px-8 hover:bg-tm-green/90" data-testid="open-admin-panel-button">
          <a href={PANEL_URL} target="_blank" rel="noreferrer">Open admin panel <ExternalLink className="ml-2 h-4 w-4" /></a>
        </Button>
      </div>
    </div>
  );
}
